import i18n from '@/i18n';

const meta = {
  loadState: true,
  auth: true,
  isAuthPage: false,
  permissions: [
    {
      subject: 'event.assets',
      actions: ['list-all'],
    }
  ],
  title: i18n.global.t('assets')
}

export default [
  {
    path: '/events',
    name: 'events',
    component: () => import('../../views/Proxy.vue'),
    meta,
    children: [
      {
        path: 'promotions',
        name: 'event-promotions',
        meta: { ...meta, title: i18n.global.t('promotions') },
        component: () => import('../../views/events/Promotions.vue'),
      },
      {
        path: 'promotion',
        name: 'event-promotion',
        meta: { ...meta, title: i18n.global.t('promotions') },
        component: () => import('../../views/events/Promotions.vue'),
        children: [
          {
            path: 'new',
            name: 'event-promotion-new',
            meta: { ...meta, title: i18n.global.t('new_event_promotion') },
            component: () => import('../../views/events/PromotionFirstStep.vue'),
          },
          {
            path: 'new-theming',
            name: 'event-promotion-new-theming',
            meta: { ...meta, title: i18n.global.t('create_event_theming') },
            component: () => import('../../views/events/PromotionTheming.vue'),
          },
          {
            path: 'new-banner',
            name: 'event-promotion-new-banner',
            meta: { ...meta, title: i18n.global.t('create_event_banner') },
            component: () => import('../../views/events/PromotionBanner.vue'),
          },
          {
            path: ':id(\\d+)',
            name: 'event-promotion-details-theming',
            meta: { ...meta, title: i18n.global.t('update_event_theming') },
            component: () => import('../../views/events/PromotionTheming.vue'),
          },
          {
            path: 'banner/:id(\\d+)',
            name: 'event-promotion-details-banner',
            meta: { ...meta, title: i18n.global.t('update_event_banner') },
            component: () => import('../../views/events/PromotionBanner.vue'),
          },
        ]
      },
      {
        path: 'assets',
        name: 'event-assets',
        meta: { ...meta, title: i18n.global.t('event_assets') },
        component: () => import('../../views/events/Assets.vue'),
        children: [
          {
            path: 'new',
            name: 'event-assets-new',
            meta: { ...meta, title: i18n.global.t('new_event_assets') },
            component: () => import('../../views/events/Asset.vue'),
          },
          {
            path: ':id(\\d+)',
            name: 'event-assets-details',
            meta: { ...meta, title: i18n.global.t('update_event_assets') },
            component: () => import('../../views/events/Asset.vue'),
          },
        ]
      },
    ]
  },
];
